export default {
  RETURN: {
    value: 'return',
    label: '退货退款',
  },
  REFUND: {
    value: 'refund',
    label: '仅退款',
  }
}